import React, { useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import BookingModal from "../components/BookingModal";
import MobileCallBar from "../components/MobileCallBar";
import {
  HeroSection,
  HowItWorksSection,
  SecuritySection,
  PricingSection,
  DimensionsSection,
  LocationSection,
  ReviewsSection,
  FAQSection,
  ContactSection
} from "../components/homepage";

// Fix Leaflet marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const Homepage = () => {
  const [selectedSize, setSelectedSize] = useState('medium');
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  const openBookingModal = () => setIsBookingModalOpen(true);
  const closeBookingModal = () => setIsBookingModalOpen(false);

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <HeroSection onBookClick={openBookingModal} />
      <HowItWorksSection />
      <SecuritySection />
      <PricingSection 
        selectedSize={selectedSize} 
        setSelectedSize={setSelectedSize} 
        onBookClick={openBookingModal} 
      />
      <DimensionsSection />
      <LocationSection />
      <ReviewsSection />
      <FAQSection />
      <ContactSection />

      {/* Booking Modal */}
      <BookingModal 
        isOpen={isBookingModalOpen} 
        onClose={closeBookingModal}
        initialSize={selectedSize}
      />

      {/* Mobile Call Bar - Fixed bottom on mobile */}
      <MobileCallBar onBookClick={openBookingModal} />
      
      {/* Spacer for mobile bottom bar */}
      <div className="h-20 md:hidden" />
    </div>
  );
};

export default Homepage;
